module.exports = __webpack_public_path__ + "static/media/comment-music.1a2ca105.svg";